<!-- src/components/MessageBanner.vue -->
<template>
    <div v-if="message" :class="['message-banner', variant]">
      {{ message }}
    </div>
  </template>
  
  <script>
  export default {
    name: 'MessageBanner',
    props: {
      message:   { type: String, default: '' },
      variant:   { type: String, default: 'success' }
    }
  };
  </script>
  
  <style scoped>
  .message-banner {
    padding: var(--space-sm, 10px);
    margin-bottom: var(--space-md, 15px);
    border-radius: 4px;
    color: var(--color-text, #333);
  }
  .message-banner.success {
    background: var(--color-success, #e1f7dc);
    border: 1px solid var(--color-success-border, #b6e3b5);
  }
  .message-banner.error {
    background: var(--color-error-bg, #fdecea);
    border: 1px solid var(--color-error-border, #f5c6cb);
    color: var(--color-error-text, #a94442);
  }
  </style>
  